<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoadForm">
            <template slot="BodyFormLoad">
                <div class="row">
                    <div class="col-lg-6 ">
                        <label >Nombre de la Empresa *</label>
                        <input type="text" v-model="Clientes.Nombre" class="form-control form-control-sm" placeholder="Nombre" id="Nombre" name="Nombre" />
                        <Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
                    </div>     
        
                    <div class="col-lg-6">
                        <label >Nombre del Contacto (Persona) *</label>
                        <input type="text" v-model="Clientes.Contacto" class="form-control form-control-sm" placeholder="Contacto" />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Contacto" :Mensaje="errorvalidacion.Contacto[0]"></Cvalidation></label>
                    </div>  
        
                    <div class="col-lg-6">
                        <label >Dirección *</label>
                        <input type="text" v-model="Clientes.Direccion"  class="form-control form-control-sm" placeholder="Dirección" />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Direccion" :Mensaje="errorvalidacion.Direccion[0]"></Cvalidation></label>
                    </div>
        
                    <div class="col-lg-3 ">
                        <label >Ciudad *</label>
                        <input type="text" v-model="Clientes.Ciudad" class="form-control form-control-sm"
                                placeholder="Ciudad" />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Ciudad" :Mensaje="errorvalidacion.Ciudad[0]"></Cvalidation></label>
                    </div>

                    <div class="col-lg-3 ">
                        <label >Estado </label>
                        <input type="text" v-model="Clientes.Estado" class="form-control form-control-sm"
                                placeholder="Estado" />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Estado" :Mensaje="errorvalidacion.Estado[0]"></Cvalidation></label>
                    </div>
                               
                    <div class="col-lg-4">
                        <label >Teléfono *</label>
                            <input type="text" v-model="Clientes.Telefono" class="form-control form-control-sm"  placeholder="Teléfono" />
                            <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Telefono" :Mensaje="errorvalidacion.Telefono[0]"></Cvalidation></label>
                    </div>
        
                    <div class="col-lg-4 ">
                        <label >Correo *</label>
                        <input  v-model="Clientes.Correo" class="form-control form-control-sm"  placeholder="Correo" />        
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Correo" :Mensaje="errorvalidacion.Correo[0]"></Cvalidation></label>
                    </div>
        
                    <div class="col-lg-4 ">
                        <label >Pais </label>
                        <input  v-model="Clientes.Pais" class="form-control form-control-sm"  placeholder="Pais" />        
                        <!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Correo" :Mensaje="errorvalidacion.Correo[0]"></Cvalidation></label> -->
                    </div>
                                               
                    <div class=" col-lg-6">
                        <label >Datos de Facturacion</label>
                        <textarea rows="5" class="form-control form-control-sm" v-model="Clientes.Dfac"></textarea>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Dfac" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
        
                    <div class="col-lg-4 d-flex justify-content-end p-0">
                        <div class="avatar-upload-logocliente">
                            <div class="avatar-preview">
                                <div id="ImagePreviewLogo" :style="'background-image:url('+Clientes.LogoCliente+');background-size:contain'" :src="Clientes.LogoCliente">

                                    <div class="d-flex h-100 align-items-center justify-content-center" v-if="AltLogoContacto">
                                        <h4>Logo</h4>
                                    </div>
                                    <!-- PONER ESTO DENTRO DEL DIV -->
                                    <!-- :style="'background-image: url('+Equipo.ImagenEspecificaciones+');'" :src="Equipo.ImagenEspecificaciones" -->
                                </div>
                            </div>
                        </div>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.LogoClientes" :Mensaje="errorvalidacion.LogoClientes[0]"></Cvalidation></label>
                    </div>
                    <div class="col-lg-2">
                        <label title="Seleccionar Imagen" for="logocliente" style="cursor:pointer" class="btn-icon mb-2"><i class=" mt-2 fa fa-pencil"></i></label>
                        <input @change="CambiarLogo($event)" class="d-none" type="file" id="logocliente" ref="logocliente" name="logocliente" accept=".png, .jpg, .jpeg">
                        <br>
                        <button @click="EliminarImagen" class="btn-icon-02"><i class="fa fa-trash"></i></button>
                    </div>
                    <!--fin col-6-->
                </div>
        
                <!-- El componente para la tabla del formulario-->
                <!-- <Clistform :pConfigLoad="ConfigLoad" v-if="Clientes.IdCliente>0" :ShowButtonTop="ShowButtonTop" :NombreTabla="NombreTablaForm" :EmitSeccionTabla="EmitSeccionTabla" :TituloBoton="TituloBoton">
                    <template slot="header_table_form">
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>Acciones</th>
                    </template>
                    <template slot="body_table_form">
                        <tr v-for="(item,key,index) in ListaUsuarios" :key="index">
                            <td>{{ item.Nombre + " " + item.Apellido }}</td>
                            <td>{{ item.Candado }}</td>
                            <td>
                                <button
                                    @click="Editar(item.IdUsuario)"
                                    title="Editar"
                                    data-backdrop="static"
                                    data-keyboard="false"
                                    data-toggle="modal"
                                    :data-target="'#'+EmitSeccionTabla"
                                    class="btn-icon mr-2"
                                ><i class="fa fa-pencil"></i></button>
                                <button
                                    @click="Eliminar(item.IdUsuario)"
                                    class="btn-icon-02"
                                ><i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </template>
                </Clistform> -->
            </template>
        </CLoader>
        <div  class="modal-footer">

			<button type="button" class="btn btn-04 ban mr-2" @click="cancelForm"> Cerrar </button>

			<button type="button" class="btn btn-01" @click="Guardar">
				<i v-if="bandera" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
				<i v-else class="fa fa-plus-circle"></i> Guardar
			</button>

        </div>
    </div>
</template>

<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
import CLoader from "@/components/CLoader.vue";
import Config from "@/helpers/VarConfig.js";

export default {
    name:'Form',
    props:['IdCliente','poBtnSave'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'cliente',//Sirve para donde va regresar
            Clientes:{
                IdCliente:0,
                Nombre:"",
                Telefono:"",
                Direccion:"",
                Correo:"",
                Ciudad:"",
                Pais:"",
                Estado:"",
                CP:"", 
                IdSucursal:"",
                Contacto:"",
                Dfac:"",
                LogoCliente:""
            },
			Ruta:"",
			ConfigLoadForm:{
                ShowLoader: false,
				ClassLoad:  true,
            },
            urlApi:"clientes/recovery",
            errorvalidacion:[],
            bandera:false,
			AltLogoContacto:true,
			ValidElement:Config.validImage2m,
        }
    },
    components:{
        Cbtnsave,
        Cvalidation,
		CLoader
    },
    methods :
    {
        async Guardar()
        {
            let formData = new FormData();

            formData.set('IdCliente',this.Clientes.IdCliente);
            formData.set('Nombre',this.Clientes.Nombre);
            formData.set('Telefono', this.Clientes.Telefono);
            formData.set('Direccion',this.Clientes.Direccion);
            formData.set('Correo',this.Clientes.Correo);
            formData.set('Ciudad', this.Clientes.Ciudad);
            formData.set('Pais', this.Clientes.Pais);
            formData.set('Estado', this.Clientes.Estado);
            formData.set('CP', this.Clientes.CP);
            formData.set('Contacto', this.Clientes.Contacto);
            formData.set('Dfac', this.Clientes.Dfac);
            formData.set('CorreoAntiguo', this.CorreoAntiguo);

            // RECUPERAR LOGO DEL CLIENTE
            let image=this.$refs.logocliente.files[0];
            formData.append('LogoClientes',image);
            if (this.Clientes.LogoCliente!="") {
                let index=this.Clientes.LogoCliente.lastIndexOf("/")+1;
			    let cadena=this.Clientes.LogoCliente.substr(index);
                formData.set('LogoClientesPrevio',"/"+cadena);   
            }

            this.bandera=true;
            await this.$http.post(
                'crmcontactos/post',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'

                    }
                },
            ).then( (res) => {
                this.bandera=false;
                this.$toast.success('Información guardada');
                $('#ModalNewUser').modal('hide');
                this.bus.$emit('ListCcliente');
            }).catch( err => {
                this.bandera=false;
                this.errorvalidacion=err.response.data.message.errores;
                this.$toast.warning('Complete los campos');
            });
        },
        Limpiar()
        {
            this.AltLogoContacto=true;
            this.Clientes.Nombre="",
            this.Clientes.Telefono="",
            this.Clientes.Direccion="",
            this.Clientes.Correo="",
            this.Clientes.Ciudad=""
            this.Clientes.Pais="",
            this.Clientes.Estado="",
            this.Clientes.CP="",
            this.Clientes.Contacto="",
            this.Clientes.Dfac="",
            this.Clientes.IdCliente=0,
            this.Clientes. IdSucursal="",
            this.Clientes.LogoCliente="",
            this.errorvalidacion=[""],
            this.Ruta="",
            // LIMPIAR LA IMAGEN
            $("#ImagePreviewLogo").css('background-image','url()');
            $("#ImagePreviewLogo").css('background-size','contain');
            // this.$refs.logocliente.value="";
        },
		cancelForm() {
			$('#ModalNewUser').modal('hide');
		},
		EliminarImagen(){
            if (this.$refs.logocliente.files[0]!=undefined || this.Clientes.LogoCliente!="") {
                this.$swal({
                title: 'Esta seguro que desea eliminar esta imagen?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        this.$toast.success('Información eliminada');
                        $("#ImagePreviewLogo").css('background-image','url()');
                        $("#ImagePreviewLogo").css('background-size','contain');
                        // console.log(this.$refs.logocliente.files);
                        this.$refs.logocliente.value=null;
                        this.Clientes.LogoCliente="";
                        this.AltLogoContacto=true;
                    } 
                });   
            }
            else{
                this.$toast.info('No hay una imagen para eliminar');
            }
        },
        CambiarLogo(event){
            this.$uploadImagePreview(event,this.ValidElement,Array('Img','ImagePreviewLogo'));
            this.AltLogoContacto=false;
        }
    },
    created() {
        this.Clientes.IdCliente=0;
		this.Limpiar();
    }
}
</script>
